import { createContext } from 'react'
import type { ThemeMode } from '@bandos/shared'

export interface ThemeContextType {
  theme: ThemeMode
  setTheme: (theme: ThemeMode) => void
  toggleTheme: () => void
  syncFromProfile: (profileTheme: ThemeMode | undefined) => void
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined)
